import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';

function HardModeToggle({ hardMode, setHardMode }) {
  return (
    <FormControlLabel
      control={<Switch checked={hardMode} onChange={() => setHardMode(!hardMode)} />}
      label="Hard Mode"
    />
  );
}

export default HardModeToggle;
